<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-form-select-input
                    :options="venues"
                    v-model="venueId"
                ></app-form-select-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-mail-filters
                    @filter="onFilter"
                    :venue="venue"
                ></app-mail-filters>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-mails-list
                    v-if="venueSelected"
                    :the-client="client"
                    :venue="venue"
                    ref="mails-list"
                ></app-mails-list>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import appMailFilters from './MailFilters'
import appMailsList from './MailList'
export default {
    components: {
        appMailFilters,
        appMailsList,
    },
    data: () => ({
        //
        venues: [],
        venueId: '',
    }),
    computed: {
        theFilters() {
            return {
                ...this.filters,
                venueId: this.venueId,
            }
        },
        venueSelected() {
            return !!this.venueId
        },
        venue() {
            return this.venues.find(item => item.id === this.venueId)
        },
    },
    methods: {
        onFilter(filters) {
            this.$refs['mails-list'].refresh(filters)
        },
        async loadVenues() {
            const { data } = await repo.get(`clients/${this.client.id}/venues`)
            this.venues = data
            if (this.venues.length !== 1) return
            this.venueId = this.venues[0].id
        },
    },
    created() {
        this.loadVenues()
    },
}
</script>
